export default {
  article: {
    title: 'USFans Spreadsheet: Kompletny przewodnik dla początkujących',
    notFound: 'Nie znaleziono artykułu',
    updated: 'Ostatnia aktualizacja: sierpień 2026',
    author: 'Zespół redakcyjny USFansLink',
    quickLabel: 'Szybka odpowiedź',
    quickText: 'Arkusz USFans to uporządkowany katalog linków do produktów, kategorii, danych sprzedawców i zasobów zakupowych. Ten przewodnik wyjaśnia, jak go czytać, co sprawdzić przed zamówieniem i jak unikać typowych błędów.',
    intro1: 'Jeśli dopiero poznajesz ekosystem USFans, arkusz może na początku wyglądać jak zwykła lista linków. W rzeczywistości to uporządkowane źródło zakupowe, które łączy Cię z szeroką gamą produktów — od sneakersów i bluz po koszulki sportowe i akcesoria.',
    intro2: 'Ten przewodnik wyjaśnia, czym jest arkusz, co w nim znajdziesz, jak z niego korzystać krok po kroku oraz co sprawdzić przed złożeniem zamówienia. Został napisany dla początkujących, więc nie potrzebujesz wcześniejszego doświadczenia.',
    s1Title: 'Czym jest arkusz USFans?',
    s1p1: 'Arkusz USFans to uporządkowany sposób organizowania linków do produktów, kategorii i powiązanych zasobów zakupowych w jednym miejscu. Zamiast szukać na wielu stronach, możesz przeglądać uporządkowane kategorie i przejść prosto do wybranego produktu na głównej stronie.',
    s1p2: 'Arkusz jest popularny, ponieważ oszczędza czas. Grupuje produkty według kategorii, łączy linki w całość i daje jasny punkt wyjścia do porównywania produktów przed podjęciem decyzji.',
    s2Title: 'Co znajdziesz w środku',
    s2p1: 'Arkusz jest podzielony na przejrzyste kategorie produktów. Do najczęstszych należą:',
    s2Item1: 'Buty — sneakersy i obuwie codzienne',
    s2Item2: 'Bluzy i swetry do noszenia na co dzień',
    s2Item3: 'Koszulki w różnych stylach i kolorach',
    s2Item4: 'Kurtki i odzież wierzchnia',
    s2Item5: 'Spodnie i szorty',
    s2Item6: 'Nakrycia głowy, takie jak czapki i beanie',
    s2Item7: 'Dopasowane zestawy i odzież sportowa',
    s2Item8: 'Koszulki sportowe, akcesoria, torby, paski, perfumy i inne',
    s3Title: 'Jak korzystać z arkusza krok po kroku',
    s3p1: 'Korzystanie z arkusza jest proste. Postępuj według tych kroków, aby w pełni go wykorzystać:',
    s3Step1: 'Wybierz kategorię, która odpowiada temu, czego szukasz.',
    s3Step2: 'Kliknij link kategorii, aby otworzyć listę produktów na głównej stronie.',
    s3Step3: 'Przeglądaj dostępne produkty i porównuj ich szczegóły.',
    s3Step4: 'Dokładnie sprawdź opis produktu, dostępne rozmiary i zdjęcia.',
    s3Step5: 'Gdy będziesz gotowy, dokończ standardowy proces zakupu na głównej stronie.',
    s4Title: 'Co sprawdzić przed złożeniem zamówienia',
    s4p1: 'Szybka kontrola przed zamówieniem może zaoszczędzić czas i zapobiec błędom. Skorzystaj z poniższej tabeli jako prostej listy kontrolnej.',
    s4HeadFactor: 'Czynnik',
    s4HeadCheck: 'Co sprawdzić',
    s4HeadWhy: 'Dlaczego to ważne',
    s4r1Factor: 'Produkt',
    s4r1Check: 'Szczegóły, rozmiary i zdjęcia',
    s4r1Why: 'Pomaga uniknąć zamówienia złego produktu',
    s4r2Factor: 'Sprzedawca',
    s4r2Check: 'Informacje i reputacja sprzedawcy',
    s4r2Why: 'Pozwala porównać opcje przed decyzją',
    s4r3Factor: 'QC',
    s4r3Check: 'Zdjęcia i szczegóły inspekcji',
    s4r3Why: 'Daje lepsze wyobrażenie o rzeczywistej jakości',
    s4r4Factor: 'Wysyłka',
    s4r4Check: 'Metoda, koszt i czas dostawy',
    s4r4Why: 'Pomaga zaplanować i zrozumieć całkowity koszt',
    s5Title: 'Wysyłka, QC i bezpieczeństwo',
    s5p1: 'Koszty wysyłki i czas dostawy mogą się różnić w zależności od produktu, miejsca docelowego i wybranej metody. Zawsze sprawdzaj szczegóły wysyłki przed sfinalizowaniem zamówienia, aby uniknąć niespodzianek.',
    s5p2: 'Kontrola jakości, często skracana do QC, odnosi się do kontroli wykonywanych przed wysyłką produktu. Szukanie zdjęć QC i informacji o inspekcji może pomóc w realistycznym określeniu oczekiwań co do otrzymanego produktu.',
    s6Title: 'Czy USFans jest legalne?',
    s6p1: 'USFansLink jest niezależnym źródłem informacji i nie sprzedaje produktów bezpośrednio. Jak przy każdym zakupie, warto samodzielnie weryfikować ważne szczegóły, sprawdzać informacje o produkcie i rozumieć zasady wysyłki oraz zwrotów przed zakupem. Ostrożność pomaga robić zakupy z pewnością.',
    faqTitle: 'Często zadawane pytania',
    faq1q: 'Czy potrzebuję konta, aby korzystać z arkusza?',
    faq1a: 'Sam arkusz możesz przeglądać swobodnie. Konto na głównej stronie może być potrzebne do dokończenia zakupu.',
    faq2q: 'Czy ceny są pokazane w arkuszu?',
    faq2a: 'Ceny i dostępność są zarządzane przez główną stronę. Sprawdź stronę produktu, aby poznać aktualne ceny.',
    faq3q: 'Czy mogę porównywać produkty w różnych kategoriach?',
    faq3a: 'Tak. Arkusz jest zorganizowany tak, abyś mógł przechodzić między kategoriami i porównywać podobne produkty przed decyzją.',
    faq4q: 'Jak często arkusz jest aktualizowany?',
    faq4a: 'USFansLink regularnie utrzymuje i aktualizuje strukturę oraz linki. Dostępność poszczególnych produktów jest kontrolowana przez główną stronę.',
    ctaTitle: 'Gotowy, aby odkryć arkusz?',
    ctaText: 'Przeglądaj uporządkowane kategorie, porównuj produkty i przejdź prosto na główną stronę, gdy znajdziesz to, czego chcesz.',
    ctaButton: 'Odkryj USFans Spreadsheet',
    backHome: 'Wróć do strony głównej',
    related: 'Powiązane zasoby',
  },
};